<template>
	<v-dialog max-width="500px" v-model="isOpen" persistent>
		<v-form :disabled="!isEditable">
			<v-card class="pa-4">
				<v-row>
					<v-col md="12">
						<h1 class="pl-md-1 font-weight-light primary--text">
							Llamada
						</h1>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="12" cols="12">
						<v-card elevation="0" class="px-md-4">
							<!-- <v-row>
								<v-col md="12" class="mt-md-1">
									<h4 class="font-weight-light primary--text">
										Comercial
									</h4>
								</v-col>
							</v-row>
							<v-divider></v-divider> -->
							<v-row>
								<v-col md="12" class="mb-md-n4">
									<v-combobox
										clearable
										chips
										hide-selected
										:items="comerciales"
										item-value="item"
										item-text="nombreCompleto"
										v-model="form.comercial"
										label="Comercial"
									>
										<template #item="{ item }">
											<v-row>
												<v-col cols="8">
													{{ item.nombreCompleto }}
												</v-col>
												<v-col
													v-if="item.estado"
													cols="4"
												>
													<v-chip
														label
														:color="
															estadoComercial[
																item.estado
															]
														"
														medium
														class="
															d-flex
															justify-center
															overline
														"
													>
														{{ item.estado }}
													</v-chip>
												</v-col>
											</v-row>
										</template>
										<template #selection="{ item }">
											<v-chip
												:color="
													!isEditable
														? 'orange lighten-3'
														: 'orange'
												"
												class="white--text"
											>
												<v-icon left size="20">
													mdi-account-circle-outline
												</v-icon>
												{{ item.nombreCompleto }}
											</v-chip>
										</template>
									</v-combobox>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="12" cols="12">
						<v-card elevation="0" class="px-md-4">
							<!-- <v-row>
								<v-col md="12" class="mt-md-1">
									<h4 class="font-weight-light primary--text">
										Tipo
									</h4>
								</v-col>
							</v-row>
							<v-divider></v-divider> -->
							<v-row>
								<v-col md="12" class="mb-md-n4">
									<v-combobox
										clearable
										chips
										hide-selected
										:items="opciones.noInteresado.tipo"
										item-value="encoded"
										item-text="human"
										:return-object="false"
										v-model="form.no_interesado.tipo"
										label="Tipo"
									>
										<template #selection="{ item }">
											<v-chip
												:color="
													!isEditable
														? 'indigo lighten-3'
														: 'indigo'
												"
												class="white--text"
											>
												{{
													opciones.noInteresado.tipo.find(
														(opcion) =>
															opcion.encoded ==
															item
													).human
												}}
												<v-icon class="ml-1">
													mdi-ticket
												</v-icon>
											</v-chip>
										</template>
									</v-combobox>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-row v-if="checkRazonNoInteresado">
					<v-col md="12" cols="12" class="pr-md-1">
						<v-card elevation="0" class="px-md-4">
							<!-- <v-row>
								<v-col md="12" class="mb-md-1 mt-md-1">
									<h4 class="font-weight-light primary--text">
										Razón no interesado
									</h4>
								</v-col>
							</v-row>
							<v-divider></v-divider> -->
							<v-row>
								<v-col md="12" class="mb-md-n4">
									<v-combobox
										clearable
										chips
										hide-selected
										v-model="form.no_interesado.razon"
										:items="opciones.noInteresado.razon"
										item-text="human"
										item-value="encoded"
										:return-object="false"
										label="Razón"
									>
										<template #selection="{ item }">
											<v-chip
												:color="
													!isEditable
														? 'pink lighten-3'
														: 'pink accent-3'
												"
												class="white--text"
											>
												{{
													opciones.noInteresado.razon.find(
														(opcion) =>
															opcion.encoded ==
															item
													).human
												}}
												<v-icon class="ml-1">
													mdi-ticket
												</v-icon>
											</v-chip>
										</template>
									</v-combobox>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-row>
					<v-col md="12" cols="12">
						<v-card elevation="0" class="px-md-4">
							<!-- <v-row>
								<v-col md="12" class="mb-md-1 mt-md-1">
									<h4 class="font-weight-light primary--text">
										Notas
									</h4>
								</v-col>
							</v-row>
							<v-divider></v-divider> -->
							<v-row>
								<v-col md="12" class="mb-md-n4">
									<v-textarea
										append-icon="mdi-comment"
										class="mx-2"
										label="Comentarios"
										auto-grow
										v-model="notas"
									></v-textarea>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<v-card-actions class="justify-end mb-md-n4">
					<v-btn color="primary" depressed v-if="isEditable" @click="save">
						Guardar
					</v-btn>
					<v-btn text color="red" @click="closeForm()">
						Cerrar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import defaultAtencionNoInterestForm from '@/util/atenciones/defaultAtencionNoInterestForm';
// import Vue from 'vue'
// Vue.forceUpdate();

export default {
	name: 'NoInterestForm',
	data: () => ({
		estadoComercial: {
			ALTA: 'success',
			BAJA: 'warning',
			INACTIVO: 'error',
			VACACIONES: 'blue',
		},
		activePicker: null,
		menu: false,
	}),
	computed: {
		isOpen: {
			get() {
				return this.$store.state.teletrabajo.NoInterestForm['isOpen'];
			},
			set(val) {
				this.clearFields();
				this.$store.state.teletrabajo.NoInterestForm['isOpen'] = val;
			},
		},
		notas: {
			get() {
				return this.$store.state.teletrabajo.NoInterestForm.form.notas;
			},
			set(val) {
				this.$store.state.teletrabajo.NoInterestForm.form.notas = val;
			},
		},
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
		...mapState('teletrabajo', {
			comerciales: (state) => state.Comerciales,
			form: (state) => state.NoInterestForm.form,
			isEditable: (state) => state.NoInterestForm['isEditable'],
		}),
		// ...mapState('util', {
		// 	opciones: (state) => state.opciones,
		// }),
		checkRazonNoInteresado() {
			if (
				this.form.no_interesado.tipo == 'NC' ||
				!this.form.no_interesado.tipo
			) {
				if (this.form.no_interesado.razon) {
					this.form.no_interesado.razon = null;
				}
				return false;
			} else {
				return true;
			}
		},
	},
	methods: {
		clone(obj) {
			return JSON.parse(JSON.stringify(obj));
		},
		clearFields() {
			this.$store.state.teletrabajo.NoInterestForm['form'] = this.clone(
				defaultAtencionNoInterestForm
			);
		},
		closeForm() {
			this.$store.state.teletrabajo.NoInterestForm.isOpen = false;
		},
		save() {
			this.closeForm();
			this.addNoInterest();
		},
		...mapActions('teletrabajo', {
			addNoInterest: 'addNoInterest',
		}),
	},
	watch: {
		comerciales: {
			immediate: true,
			handler: function () {
				this.form.comercial = this.comerciales.find(
					({ id }) => id == this.$store.state.login.id
				);
			},
		},
	},
};
</script>
